<template>
    <v-layout align-center class="stepper-item" :class="{'py-3': $vuetify.breakpoint.xs, 'mb-4': $vuetify.breakpoint.smAndUp}">
        <div class="step-circle mr-3" :class="{'step-circle--disabled': disabled}"></div>
        <v-flex>
            <component :decor="false" :disable="disabled" :active="active"
                       @click.native="move_to_lesson()" :is="current_component"
            ><slot></slot></component>
            <!-- <linkDark :decor="false" :disable="true"><slot></slot></linkDark> -->
        </v-flex>
        <svg v-svg
             v-show="$vuetify.breakpoint.xs"
             symbol="arrow-right"
             size="12 24"
             class="icon-small red-text mr-3"
             role="presentation"
        />
    </v-layout>
</template>

<script>

import linkDark from '@/components/ui/links/styled/link_dark.vue';
import linkRed from '@/components/ui/links/styled/link_red.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    linkDark,
    linkRed,
  },
  props: {
    disabled: {
      type   : Boolean,
      default: false,
    },
    active: {
      type   : Boolean,
      default: false,
    },
    lesson: {
      type: Number,
    },
    block: {
      type: Number,
    },
  },
  computed: {
    current_component: function() {
      if (this.active) {
        return 'linkRed';
      } else {
        return 'linkDark';
      }
    },
    ...mapGetters('course_info', [
      'course_started',
      'course_completed',
      'test_started',
      'test_finished',
      'time_test',
    ]),
    ...mapGetters('testing', [
      'test_layout',
    ]),
  },
  methods: {
    ...mapMutations('course_info/steps', [
      'TO_LESSON',
    ]),
    ...mapMutations('course_info', [
      'SHOW_MOBILE',
    ]),
    ...mapActions('testing', [
      'test_hide',
    ]),
    move_to_lesson: function() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.SHOW_MOBILE();
      }
      let block = this.block;
      let lesson = this.lesson;
      this.TO_LESSON({block, lesson});
      if (this.test_layout) {
        this.test_hide();
      }
    },
  },

};
</script>

